import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import accessToken from './slice/access-token';
import loggedUser from './slice/logged-user';
import adminRole from './slice/admin-role';
import activeRoute from './slice/active-route'; // Import the activeRoute slice
import loggedEmployee from './slice/logged-employee';
import employeeAccessToken from './slice/employee-access-token';
import chartSlice from "./slice/chartSlice";
import UserQuestionData from './slice/userQuestionData';
const rootReducer = combineReducers({
  accessToken: accessToken,
  loggedUser: loggedUser,
  adminRole: adminRole,
  activeRoute: activeRoute,
  loggedEmployee: loggedEmployee,
  employeeAccessToken: employeeAccessToken,
  charts: chartSlice,
  UserQuestionData: UserQuestionData
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});
